import ChangePasswordForm from './ChangePasswordForm'

const ChangePasswordPrefs = () => {
  return <ChangePasswordForm />
}

export default ChangePasswordPrefs
